import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 24px 80px' }}>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, color: '#0D9488', textDecoration: 'none', marginBottom: 24 }}>
        <ArrowLeft size={18} /> Back to Home
      </Link>

      <h1 style={{ fontSize: 32, fontWeight: 700, marginBottom: 8 }}>Privacy Policy</h1>
      <p style={{ color: '#6B7280', marginBottom: 32 }}>Last updated: August 5, 2026</p>

      <div style={{ lineHeight: 1.8, color: '#374151' }}>
        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>1. Introduction</h2>
        <p>ElderLink ("we", "our", or "us") operates the ElderLink platform at elderlinkapp.com. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our caregiving coordination platform.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>2. Information We Collect</h2>
        <p><strong>Account Information:</strong> When you register, we collect your name, email address, phone number, and role (family member, caregiver, or agency).</p>
        <p><strong>Profile Information:</strong> Photos, certifications, availability schedules, and care preferences you provide.</p>
        <p><strong>Care Data:</strong> Shift logs, care hours, health metrics, medication records, and daily checklists entered through the platform.</p>
        <p><strong>Communications:</strong> Messages sent through the platform's messaging system.</p>
        <p><strong>Device Information:</strong> Browser type, IP address, and device identifiers for push notification delivery.</p>
        <p><strong>Third-Party Integrations:</strong> If you connect Google Calendar, we access calendar data as authorized by you through Google's OAuth consent flow.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>3. How We Use Your Information</h2>
        <p>We use the collected information to:</p>
        <ul style={{ paddingLeft: 24, marginBottom: 16 }}>
          <li>Provide and maintain the ElderLink platform</li>
          <li>Coordinate care schedules between family members and caregivers</li>
          <li>Send shift reminders, health alerts, and care notifications</li>
          <li>Process payments and manage subscriptions</li>
          <li>Sync with Google Calendar when authorized</li>
          <li>Communicate important updates about the service</li>
          <li>Improve our platform and user experience</li>
        </ul>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>4. Information Sharing</h2>
        <p>We do not sell your personal information. We share data only in these circumstances:</p>
        <ul style={{ paddingLeft: 24, marginBottom: 16 }}>
          <li><strong>Within Care Circles:</strong> Care-related data is shared among members of your care circle as needed for care coordination.</li>
          <li><strong>Service Providers:</strong> We use third-party services for email delivery (Gmail SMTP), SMS notifications (Twilio), push notifications (Web Push), and analytics.</li>
          <li><strong>Legal Requirements:</strong> We may disclose information when required by law or to protect rights, safety, or property.</li>
        </ul>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>5. Data Security</h2>
        <p>We implement industry-standard security measures including encrypted connections (HTTPS/TLS), secure password hashing, JWT-based authentication, and access controls. However, no method of electronic transmission or storage is 100% secure.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>6. Data Retention</h2>
        <p>We retain your data for as long as your account is active. You may request deletion of your account and associated data at any time by contacting us or through your account settings.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>7. Your Rights</h2>
        <p>You have the right to:</p>
        <ul style={{ paddingLeft: 24, marginBottom: 16 }}>
          <li>Access and download your personal data</li>
          <li>Correct inaccurate information</li>
          <li>Request deletion of your account</li>
          <li>Disconnect third-party integrations (e.g., Google Calendar)</li>
          <li>Opt out of non-essential notifications</li>
        </ul>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>8. Cookies and Tracking</h2>
        <p>We use local storage and session tokens for authentication. We use PostHog for product analytics to understand how the platform is used and improve the experience.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>9. Children's Privacy</h2>
        <p>ElderLink is not intended for use by individuals under the age of 18. We do not knowingly collect personal information from children.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>10. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will notify you of significant changes through the platform or via email.</p>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 32, marginBottom: 12 }}>11. Contact Us</h2>
        <p>If you have questions about this Privacy Policy, contact us at <a href="mailto:elderlinksupport@gmail.com" style={{ color: '#0D9488' }}>elderlinksupport@gmail.com</a>.</p>
      </div>
    </div>
  );
}
